import { useEffect, useState } from 'react';

import TextFieldComponent from './text-field';

function TextField({ value: initialValue, onChange, ...props }) {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleChange = (event) => {
    const { value } = event.target;
    setValue(value);
    onChange && onChange(event);
  };

  return (
    <TextFieldComponent {...props} value={value} onChange={handleChange} />
  );
}

export default TextField;
